module.exports = __webpack_public_path__ + "img/cart-updown_8303731e15@2x.7d9dac6e.jpg";